var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconWithCyrcle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 150,
    viewBox: "0 0 152 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 98,
    r: 52,
    fill: "#BCA8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 50,
    stroke: "#16161E",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6079 32.064C48.6079 34.482 50.5919 36.466 52.9479 36.466C55.3659 36.466 57.3499 34.482 57.3499 32.064C57.3499 29.646 55.3659 27.662 52.9479 27.662C50.5919 27.662 48.6079 29.646 48.6079 32.064ZM49.5999 71H56.4199V40.992H49.5999V71Z",
    fill: "#16161E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconWithCyrcle);
export default __webpack_public_path__ + "static/media/infoIconWithCyrcle.ab4cbe01d579c21607cb87d2fbf761a0.svg";
export { ForwardRef as ReactComponent };